// export const SERVER_HOSTNAME = 'http://14.248.147.45:3000'
// export const SERVER_HOSTNAME = 'http://192.168.100.7:3000'
// export const SERVER_HOSTNAME = 'http://aiot-jsc1.ddns.net:8000'
// export const SERVER_HOSTNAME = 'http://localhost:9000'
// export const SERVER_HOSTNAME = 'http://13.250.159.16:8000'
// export const SERVER_HOSTNAME = 'https://drk-cloud.com:9000'
// export const SERVER_HOSTNAME = 'https://ste-das.drk-cloud.com'
export const SERVER_HOSTNAME = 'https://indigo.drk-cloud.com'
